import { useEffect, useRef, useState } from "react";
import { usersAPI } from '../../api/usersAPI';
import useUserName from '../../common/hooks/useUserName';

export default function EmployeeSelector({ selectedPcode, setSelectedEmployee, disabled = false, placeholder = "Select Employee", triggerOnChangeEmployee = null, selectedEmployee = null, showAllOption = false }) {
    const { logedUserName } = useUserName();
    const [employees, setEmployees] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (selectedPcode && selectedPcode.trim() !== '') {
            loadEmployees();
        }
    }, [selectedPcode]);

    const loadEmployees = async () => {
        if (!selectedPcode) return;

        setIsLoading(true);
        try {
            // Using existing pattern - you may need to adjust the API call based on your backend
            const response = await usersAPI.getEmployeesByPcode(selectedPcode);
            setEmployees(response || []);
        } catch (error) {
            console.error('Error loading employees:', error);
            setEmployees([]);
        } finally {
            setIsLoading(false);
        }
    };

    const onChangeEmployee = (e) => {
        const selectedValue = e.target.value;

        if (selectedValue === 'ALL') {
            // Create a special employee object for "All Employees"
            const allEmployeesOption = { employeeCode: 'ALL', employeeName: 'All Employees' };
            setSelectedEmployee(allEmployeesOption);

            if (triggerOnChangeEmployee != null) {
                triggerOnChangeEmployee(allEmployeesOption);
            }
        } else {
            const selectedEmp = employees.find(emp => emp.employeeCode === selectedValue);
            setSelectedEmployee(selectedEmp || null);

            if (triggerOnChangeEmployee != null) {
                triggerOnChangeEmployee(selectedEmp);
            }
        }
    };

    return (
        <select
            className="form-select"
            onChange={onChangeEmployee}
            disabled={disabled || isLoading}
            value={selectedEmployee ? selectedEmployee.employeeCode : ""}
        >
            <option value="">{isLoading ? "Loading employees..." : placeholder}</option>
            {showAllOption && (
                <option value="ALL">All Employees</option>
            )}
            {
                employees.map((employee) => (
                    <option key={employee.employeeCode} value={employee.employeeCode}>
                        ({employee.employeeCode}) {employee.employeeName}
                    </option>
                ))
            }
        </select>
    );
}
